import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';

import { colorToCss } from '../../theme/utils';
import { getMargin } from '../../utils/spacing';
import { HxProps } from './type';
import { getMarginFallback } from './utils';

const Heading: FC<HxProps> = ({
  bold = false,
  center = false,
  children,
  color,
  margin,
  position,
  sx,
  type,
  uppercase = true,
}) => {
  const sxHeading = useDeepCompareMemo<SxProps<Theme>>(
    () => ({
      ...sx,
      ...getMargin(margin, getMarginFallback(type)),
      ...{ textAlign: center ? 'center' : 'start' },
      ...(color && { color: colorToCss(color) }),
      ...(bold && { fontWeight: 'bold' }),
      ...(uppercase && { textTransform: 'uppercase' }),
      ...(position === 'static' && { position: 'static' }),
    }),
    [sx, bold, center, color, margin, type, uppercase, position]
  );

  return (
    <Typography className='static' component={type} sx={sxHeading} variant={type}>
      {children}
    </Typography>
  );
};

export default Heading;
